import templatesWorker from "./templatesWorker.js";
import md5 from "crypto-js/md5";


import emojisJson from './emojis.json';
import BaseClass from "./BaseClass";

export default class socketLiveCamChat extends BaseClass {


    constructor(element) {
        super(element);

        this.connecting = false;
        this.connected = false;
        this.initDone = false;  //TODO prüfen
        this.replyMode = false; //TODO prüfen
        this.forceConnectionClose = false;
        this.mobileLayout = false;

        this.connection = null;
        this.conversationID = null;
        this.authToken = null;
        this.roomName = null;
        this.serverURL = null;
        this.currentUser = null;
        this.messageIdToHighlight = null;
        this.currentLastMessageId = null;

        this.$newUserSound = null;
        this.$videoOverlay = null;

        this.connectionCloseListener = null;
        this.camStartListener = null;
        this.camStopListener = null;
        this.contentResizedListener = null;
        this.chatDeleteMessageListener = null;
        this.camchatReactionListener = null;
        this.camchatReactionClickedListener = null;
        this.camchatSendGifListener = null;

        this.templatesWorker = new templatesWorker();

        this.connectionAttempts = 0;
        this.maxconnectionAttempts = 5;

        this.lastScrolltop = 0;


        this.init();
    }

    init() {
        this.initDomElements();
        this.initListeners();

        this.checkMobileLayout();
        this.initDone = true;
        $(document).trigger("content:loaded");
    }

    initDomElements() {
        let $newUserSound = $('#new_user_sound').first();
        if ($newUserSound.length == 1) {
            this.$newUserSound = $newUserSound;
        }

        let $videoOverlay = $('[data-type="video-overlay"]');
        if ($videoOverlay.length == 1) {
            this.$videoOverlay = $videoOverlay;
        }

    }

    initListeners() {
        let mySelf = this;
        this.camStartListener = function (event, data) {

            mySelf.authToken = data.authToken;
            mySelf.roomName = data.roomName;
            mySelf.serverURL = data.serverURL;

            if (mySelf.authToken != null && mySelf.roomName != null) {
                mySelf.initSocketConnection();
            }
        }

        this.camStopListener = function (event, data) {
            mySelf.forceConnectionClose = true;
            if (mySelf.connection != null) {
                mySelf.connection.close();
            }
            let conversationId = mySelf.conversationID;
            let $conversation = $('#conversation_' + conversationId);

            $conversation.remove();

            $('#no-conversations').removeClass('hidden');
            
            let eventData = {};
            eventData.id = 'profile_camstate';

            $(document).trigger('content:reload', eventData);
        }

        this.connectionCloseListener = function () {
            console.log('WebSocket closed ');
            mySelf.connection = null;
            mySelf.resetMessengerData();
        };

        this.contentResizedListener = function () {
            mySelf.checkMobileLayout();
        };

        this.chatDeleteMessageListener = function (event, data) {
            mySelf.deleteConversationMessage(data.msg);
        };

        this.camchatReactionListener = function (event, data) {
            const originalEvent = data.originalEvent;
            const messageId = data.contentId;
            const conversationId = data.convId;
            let selectedEmoji = originalEvent.emoji;

            if (selectedEmoji) {
                mySelf.createMessageReaction(messageId, selectedEmoji, conversationId);
            }
        };

        this.camchatReactionClickedListener = function (event, data) {
            const messageId = data.contentId;
            const clickedEmoji = data.clickedReaction;
            const conversationId = data.conversationId;

            if (clickedEmoji) {
                mySelf.handleClickedMessageReaction(messageId, clickedEmoji, conversationId);
            }
        };

        this.camchatSendGifListener = function (event, data) {
            const conversationId = data.contentId;
            const sendTo = data.sendTo;
            const gif = data.gif;

            if (gif) {
                mySelf.sendGif(conversationId, sendTo, gif);
            }
        }

        $(document).on('creator:camchat:start', this.camStartListener);
        $(document).on('user:camchat:start', this.camStartListener);
        $(document).on('creator:camchat:stop', this.camStopListener);
        $(document).on('user:camchat:stop', this.camStopListener);
        $(document).on("content:resized", this.contentResizedListener);
        $(document).on("chat:deleteMessage", this.chatDeleteMessageListener);
        $(document).on('camchat:reaction', this.camchatReactionListener);
        $(document).on('camchat:reaction:clicked', this.camchatReactionClickedListener);
        $(document).on('camchat:send_gif', this.camchatSendGifListener);

    }

    playNewUserSound() {
        if (this.$newUserSound != null) {
            this.$newUserSound.get(0).play();
        }
    }

    checkMobileLayout() {
        if (this.getCurrentFullScreenElement() != null) {
            return false;
        }

        let minDesktopWidth = 992;
        let currentWidth = $(window).width();

        if (minDesktopWidth > currentWidth) {
            this.mobileLayout = true;
        } else {
            this.mobileLayout = false;
            $('#camchat-conversations-main-holder').removeClass('hidden');
        }
    }

    initSocketConnection() {
        if (this.connecting) {
            return;
        }

        this.connectionAttempts++;
        this.connecting = true;

        let mySelf = this;
        let connectionUrl =
            this.serverURL
            + "?room_name=" + encodeURIComponent(this.roomName)
            + "&auth_token=" + this.authToken;

        this.connection = new WebSocket(connectionUrl);

        this.connection.onopen = function () {
            mySelf.connected = true;
            mySelf.connecting = false;
            mySelf.connectionAttempts = 0;
        };


        this.connection.onclose = this.connectionCloseListener;

        this.connection.onerror = function (error) {
            console.error(error);
            mySelf.resetMessengerData();
        };

        this.connection.onmessage = function (e) {
            mySelf.parseServerResponse(e.data);
        };
    }

    closeConversation(jsonData = null) {
        let conversationId = this.currentConversationID;
        if (jsonData != null) {
            conversationId = jsonData.conversationID;
        }

        let $conversation = $('#conversation_' + conversationId);
        if ($conversation.length == 1) {
            $conversation.remove();
        }
        let url = new URL(window.location);
        if (url.hash != "") {
            let newUrl = url.href.replace(url.hash, "");
            window.location = newUrl + "#";
        }
        if (this.mobileLayout) {
            this.closeMobileConversation();
        }
    }

    reloadConversation($conversationHolder, conversationID) {
        let $messagesContainer = $conversationHolder.find('.conversation_messages').first();
        $messagesContainer.html('');
        this.requestConversationData(conversationID);
        this.lastScrolltop = $messagesContainer.scrollTop();
    }

    resetMessengerData() {
        let mySelf = this;
        mySelf.connected = false;
        mySelf.connection = null;
        mySelf.connecting = false;

        if (this.connectionAttempts >= this.maxconnectionAttempts) {
            console.error("max Attempts reached");
            return;
        }

        // falls Connection mit Absicht getrennt wurde, nicht wiederherstellen
        if (!mySelf.forceConnectionClose) {
            setTimeout(function () {
                    mySelf.initSocketConnection();
                }, 1000
            )
        }
    }

    parseServerResponse(serverResponse) {
        let mySelf = this;
        const jsonObj = JSON.parse(serverResponse);

        switch (jsonObj.type) {

            case "connectionstate":
                if (jsonObj.payload.state === "open") {
                    this.connected = true;
                    this.currentUser = jsonObj.payload.userData;

                    if (jsonObj.payload.conversationID != undefined) {
                        this.conversationID = jsonObj.payload.conversationID;
                    }
                    mySelf.requestConversation();
                } else if (jsonObj.payload.state === "close") {
                    this.connection.close();
                } else if (jsonObj.payload.state === "reconnect") {
                    this.connection.close();
                }
                break;

            case "newConversationData":
                this.createNewConversation(jsonObj.payload);
                $(document).trigger("content:loaded");
                break;

            case "conversationData":
                this.updateConversationData(jsonObj.payload);
                $(document).trigger("content:loaded");
                break;

            case "systemMessage":
                this.insertSystemMessage(jsonObj.payload);
                $(document).trigger("content:loaded");
                break;

            case "ping":
                this.sentPong(jsonObj.payload.time);
                break;


            case "modalTrigger":
                this.openModal(jsonObj.payload.url);
                break;


            case "closeConversation":
                this.closeConversation(jsonObj.payload);
                break;

            case "updateAvailable":
                this.workOnUpdates(jsonObj.payload);
                break;


            case "hideMessage":
                this.hideConversationMessage(jsonObj.payload.msgID);
                break;

            case "conversationMessage":
                this.replaceConversationMessage(jsonObj.payload.message);
                break;

            case "scheduledStreamEndInfo":
                this.showScheduledStreamEndWarning(jsonObj.payload);
                break;

            case "scheduledStreamEnd":
                this.stopCurrentStream();
                break;

            case "updateViewersAmount":
                $(document).trigger('viewers:amount:changed', {viewersAmount: jsonObj.payload.amount, dropdownID: 'viewers-list'});
                break;

            case "error":
                this.displayError(jsonObj.payload.title, jsonObj.payload.subtitle, jsonObj.payload.body);
                break;

            case "messageconfirm":
                this.resetMessageText(jsonObj.payload.conversationID, jsonObj.payload.md5);
                break;
        }
    }

    stopCurrentStream() {
        $(document).trigger('stream:event', {action: 'stopStream'});
        if (this.$videoOverlay != null) {
            this.$videoOverlay.empty();
            this.$videoOverlay.addClass('d-none');
        }
    }

    showScheduledStreamEndWarning(payload) {
        let mySelf = this;

        if (this.$videoOverlay != null) {
            let $warningTemplate = null;

            if (payload.userType == 'creator') {
                $warningTemplate = this.templatesWorker.getTemplate('js-creator_ticket_show_ending_creator_tpl');
            } else if (payload.userType == 'user') {
                $warningTemplate = this.templatesWorker.getTemplate('js-user_ticket_show_ending_creator_tpl');
                if (payload.minutePrice != undefined) {
                    let $priceDescription = $warningTemplate.find('[data-type="price_description"]').first();
                    let priceDescriptionText = $priceDescription.html();
                    priceDescriptionText = priceDescriptionText.replace("##minuteprice##", payload.minutePrice);
                    $priceDescription.html(priceDescriptionText);
                }
            }
            if ($warningTemplate == null) {
                return;
            }

            let $headLine = $warningTemplate.find('[data-type="headline"]').first();
            let headLineText = $headLine.html();
            headLineText = headLineText.replace("##seconds##", payload.secondsleft);
            $headLine.html(headLineText);

            let $stopButton = $warningTemplate.find('[data-type="stop_btn"]').first();
            let $runButton = $warningTemplate.find('[data-type="run_btn"]').first();

            $stopButton.on('click', function (event) {
                mySelf.setAutoStopStream();
                mySelf.$videoOverlay.empty();
                mySelf.$videoOverlay.addClass('d-none');
            });
            $runButton.on('click', function (event) {
                mySelf.setAutoRunStream();
                mySelf.$videoOverlay.empty();
                mySelf.$videoOverlay.addClass('d-none');
            });

            this.$videoOverlay.html($warningTemplate);
            this.$videoOverlay.removeClass('d-none');
        }
    }

    setAutoStopStream() {
        let message = {};
        message.handler = "handling";
        message.method = "setAutoStopStream";
        message.payload = {};
        this.sendSocketMessage(message);
    }

    setAutoRunStream() {
        let message = {};
        message.handler = "handling";
        message.method = "setAutoRunStream";
        message.payload = {};
        this.sendSocketMessage(message);
    }

    openModal(url) {
        $(document).trigger('modal:open', {
            contentUrl: url
        });
    }

    resetMessageText(conversationID, md5Hash) {
        let $conversationHolder = $('#conversation_' + conversationID);

        if ($conversationHolder.length == 0) {
            $conversationHolder = $('#conversation_new');
        }

        if ($conversationHolder.length == 1) {
            let $form = $conversationHolder.find('[data-type="messageform"]').first();
            let $textarea = $form.find('textarea').first();
            let currentTxt = $textarea.val().trim();
            let currentMd5Hash = md5(currentTxt);

            if (currentMd5Hash.toString() == md5Hash) {
                $textarea.val('');
                $textarea.trigger('change');
                $conversationHolder.attr('id', 'conversation_' + conversationID);
            }
        }
    }


    workOnUpdates(payload) {
        switch (payload.data.type) {
            case "conversation":
                this.viewConversation(payload.data.id);
                if (payload.data.id == this.conversationID) {
                    let maxMessageId = this.getMaxLoadedMessageId();
                    this.requestConversationData(payload.data.id, maxMessageId);
                }
                break;
        }
    }

    updateBalance(currentBalance) {
        $('[data-type="usercredit"]').html(currentBalance);
    }

    displayError(title, subtitle, body) {
        $(document).trigger("toast:show", {
            title: title,
            subtitle: subtitle,
            body: body,
            type: "error",
        });
    }

    replaceConversationMessage(message) {
        let mySelf = this;
        let conversationId = message.conversation_id;

        let $conversationHolder = $('#conversation_' + message.conversation_id);
        let $messagesContainer = $conversationHolder.find('.conversation_messages').first();
        let $messageContainer = $messagesContainer.find('[data-message-id="' + message.id + '"]').first();

        let tmpHtml = "";
        tmpHtml = this.templatesWorker.loadMessageTemplate(this.currentUser, $messagesContainer, message, tmpHtml, true);

        $messageContainer.replaceWith(tmpHtml);

        // re-init reply
        $('.conversation_reply').off('click');
        $('.conversation_reply').on('click', function (event) {
                let message = $(this).closest('message');
                mySelf.initMessageReply($conversationHolder, conversationId, message);
            }
        );

        $(document).trigger("content:loaded");
    }

    hideConversationMessage(msgID) {
        let $message = $('[data-message-id="' + msgID + '"]');
        if ($message.length > 0) {
            $message.find('.js-message-image').remove();
            $message.remove();
        }
    }


    /*********CONVERSATIONS*********/
    viewConversation(conversationID) {
        this.currentConversationID = conversationID;
        let $conversationsContainer = $('#camchat-conversations-holder');
        let $conversation = $('#conversation_' + conversationID);

        if ($conversation.length == 0) {
            $conversation = this.templatesWorker.createNewConversation($conversationsContainer, conversationID);
        }

        if ($conversation.hasClass('hidden')) {
            this.cleanConversationContainer(conversationID);
            this.requestConversationData(conversationID);
        }

        $('#camchat-conversations-holder').children().addClass('hidden');
        $conversation.removeClass('hidden');

        if (this.mobileLayout) {
            $('#camchat-conversations-main-holder').removeClass('hidden');
        }

        $(document).trigger("content:loaded");
    }

    closeMobileConversation() {
        $('#camchat-conversations-main-holder').addClass('hidden');
    }


    insertSystemMessage(jsonData) {
        if (jsonData.data === null) {
            return;
        }
        let mySelf = this;
        let conversationID = jsonData.conversationID;
        let messageContent = jsonData.content;
        let $conversationHolder = $('#conversation_' + conversationID);

        if ($conversationHolder.length == 0) {
            // Konversation bisher nicht geladen
            return;
        }

        let $messagesContainer = $conversationHolder.find('.conversation_messages').first();

        if ($messagesContainer.length == 1) {
            let messageHTML = mySelf.templatesWorker.loadSystemMessageTemplate(messageContent);

            $messagesContainer.append(messageHTML);

            let scrollHeight = $messagesContainer[0].scrollHeight + 1000; // In manchen Fällen wird nicht ausreichend tief durchgescrollt.
            $messagesContainer.scrollTop(scrollHeight);

            if (mySelf.lastScrolltop == 0) {
                mySelf.lastScrolltop = $messagesContainer.scrollTop();
            }

            if (jsonData.data != undefined && jsonData.data.sound != undefined) {
                if (jsonData.data.sound == 'newUser') {
                    mySelf.playNewUserSound();
                }
            }

        }
    }


    updateConversationData(jsonData) {
        if (jsonData.data === null) {
            return;
        }
        let mySelf = this;
        let conversationID = jsonData.data.id;
        let firstMessageID = '';
        let $conversationHolder = $('#conversation_' + conversationID);
        let $header = $conversationHolder.find('.js-header').first();
        let appendMessages = false;
        this.currentLastMessageId = jsonData.data.last_message_id;

        if (jsonData.data.firstMessageID != undefined) {
            firstMessageID = jsonData.data.firstMessageID;
        }

        if (jsonData.append != undefined && jsonData.append == 1) {
            appendMessages = true;
        }

        if ($conversationHolder.length == 0) {
            // Konversation bisher nicht geladen
            let $conversationsContainer = $('#camchat-conversations-holder');
            $conversationHolder = this.templatesWorker.createNewConversation($conversationsContainer, conversationID);
            return;
        }

        if ($conversationHolder.hasClass('hidden')) {
            return;
        }

        if ($header.length == 0) {
            // Diese Konversation wurde bisher nicht geladen, daher neu aus dem Template laden.
            $header = this.templatesWorker.loadConversationTemplate($conversationHolder, conversationID);

            this.initMessageForm($conversationHolder, conversationID);
        }

        let $messageForm = $conversationHolder.find('[data-type="messageform"]').first();
        if ($messageForm.length == 1) {
            let messageFormHeight = $messageForm.innerHeight();
            if (messageFormHeight > 0) {
                $('html').css('--height-messenger-form', messageFormHeight + 'px');
            }
        }

        let $messagesContainer = $conversationHolder.find('.conversation_messages').first();

        if ($messagesContainer.length == 1) {
            let maxMessageID = null;
            let html = $messagesContainer.html();
            let tmpHtml = "";
            jsonData.messages.forEach(function (message) {
                    if (message.type == "msg") {
                        tmpHtml = mySelf.templatesWorker.loadMessageTemplate(mySelf.currentUser, $messagesContainer, message, tmpHtml);
                        maxMessageID = message.id;
                    }
                }
            );

            if (!appendMessages && firstMessageID.length > 0) {
                // Ist die ID length > 0, handelt es sich um ältere Nachrichten, welche oben angefügt werden sollen
                // html = tmpHtml + html;
                $messagesContainer.prepend(tmpHtml);
            } else {
                //  html = html + tmpHtml;
                $messagesContainer.append(tmpHtml);
            }
            // update mySelf.lastScrolltop position for prevent false scrolling event
            mySelf.lastScrolltop = $messagesContainer.scrollTop();

            // $messagesContainer.html(html);

            // Messages initialisieren

            if (firstMessageID.length > 0) {
                // Wenn der Benutzer das "Gehe zu Nachricht"-Feature benutzt hat und danach nach unten gescrollt hat,
                // werden die neueren Nachrichten geholt und unten angehängt. In diesem Fall müssen wir nicht
                // zur alten ersten Nachricht scrollen
                if (!appendMessages) {
                    // nur dann scrollen, wenn es keine ältere Nachrichten sind
                    let $oldFirstMessage = $messagesContainer.find("[data-message-id='" + firstMessageID + "']").first();
                    if ($oldFirstMessage.length == 1) {
                        let newPosition = $oldFirstMessage.position().top;
                        $messagesContainer.scrollTop(newPosition);
                    }
                }
            } else {
                let scrollHeight = $messagesContainer[0].scrollHeight + 1000; // In manchen Fällen wird nicht ausreichend tief durchgescrollt.
                $messagesContainer.scrollTop(scrollHeight);
            }

            // Um mehrfache Ausführungen und unbeabsichtigte Auslösungen in anderen Konversationen zu verhindern,
            // wird der Klick-Event-Handler zuerst entfernt und dann erneut hinzugefügt.
            $('.conversation_reply').off('click');
            $('.conversation_reply').on('click', function (event) {
                    let message = $(this).closest('message');
                    mySelf.initMessageReply($conversationHolder, conversationID, message);
                }
            );

            $(document).off('click', '.message_reply--group');
            $(document).on('click', '.message_reply--group', function (event) {
                event.stopPropagation();
                let messageId = $(this).data('reply-to-message-id');

                if (messageId.length > 0) {
                    let $searchMessageContainer = $messagesContainer.find("[data-message-id='" + messageId + "']").first();
                    mySelf.messageIdToHighlight = messageId;

                    if ($searchMessageContainer.length == 0) {
                        $messagesContainer.html('');
                        mySelf.requestNextMessages(conversationID, messageId);
                    }

                    if ($searchMessageContainer.length == 1) {
                        mySelf.highlightMessage($messagesContainer);

                        let newPosition = $searchMessageContainer.offset().top;
                        let containerPosition = $messagesContainer.offset().top;
                        let scrollToPosition = newPosition - containerPosition;

                        $messagesContainer.animate({
                            scrollTop: $messagesContainer.scrollTop() + scrollToPosition
                        }, 600);
                    }
                }
            });

            if (mySelf.lastScrolltop == 0) {
                mySelf.lastScrolltop = $messagesContainer.scrollTop();
            }

            let $gotoLastMessageBtn = $conversationHolder.find('[data-id="goto-last-msg-btn"]').first();

            $messagesContainer.off('scroll');
            $messagesContainer.on('scroll', debounce(function () {
                let currentScrollTop = $messagesContainer.scrollTop();

                if (currentScrollTop > mySelf.lastScrolltop) {
                    // Scrolling down
                    mySelf.handleScrolltopBottom(conversationID, $messagesContainer);
                    mySelf.lastScrolltop = $messagesContainer.scrollTop();
                } else {
                    // Scrolling up
                    mySelf.handleScrolltopTop(conversationID, $messagesContainer);
                }

                mySelf.handleGoToEndButton($messagesContainer, $gotoLastMessageBtn);
                if (currentScrollTop > 0) {
                    mySelf.lastScrolltop = currentScrollTop;
                }
            }, 100));

            if (!appendMessages) {
                this.handleScrolltopTop(conversationID, $messagesContainer);
            }
        }

        this.highlightMessage($messagesContainer);
    }

    highlightMessage($messagesContainer) {
        if (this.messageIdToHighlight != null) {
            $messagesContainer.find('.highlight').removeClass('highlight');

            let $searchMessageContainer = $messagesContainer.find("[data-message-id='" + this.messageIdToHighlight + "']").first();

            if ($searchMessageContainer.length == 1) {
                let messageContainer = $searchMessageContainer.find("[data-type='message-content']").first();
                messageContainer.addClass('highlight');
                this.messageIdToHighlight = null;

                return true;
            }
        }

        return false;
    }

    cleanConversationContainer(conversationID) {
        let $conversationHolder = $('#conversation_' + conversationID);
        let $messagesContainer = $conversationHolder.find('.conversation_messages').first();
        $messagesContainer.html('');
        let $gotoLastMessageBtn = $conversationHolder.find('[data-id="goto-last-msg-btn"]').first();
        $gotoLastMessageBtn.addClass('hidden');
    }

    getMaxLoadedMessageId() {
        let maxMessageId = null;
        let $conversationHolder = $('#conversation_' + this.currentConversationID);
        let $messagesContainer = $conversationHolder.find('.conversation_messages').first();

        let $lastMessage = $messagesContainer.children('.message').last();
        if ($lastMessage.length == 1) {
            let lastMessageID = $lastMessage.attr('data-message-id');

            if (lastMessageID != undefined) {
                maxMessageId = lastMessageID;
            }
        }

        return maxMessageId;
    }

    initMessageReply($conversationHolder, conversationID, $message) {
        let mySelf = this;
        mySelf.replyMode = true;
        let $replyContainer = $conversationHolder.find('[id="message_reply_' + conversationID + '"]');

        let $closeButton = $replyContainer.find('[data-id="close-reply-btn"]');
        let $replyToUsernameHolder = $replyContainer.find('[data-id="message-owner"]');
        let $replyToMessageHolder = $replyContainer.find('[data-id="message-content"]');

        let $messageOwner = $message.data('message-username');
        let $messageContent = $message.find('[data-type="msg-content"]');

        $replyToUsernameHolder.text($messageOwner);
        $replyToMessageHolder.text($messageContent.text());

        let $replyToMessageId = $message.data('message-id');
        let $form = $conversationHolder.find('[data-type="messageform"]').first();
        $form.find('.js-reply_message_id').val($replyToMessageId);

        let $textarea = $form.find('textarea[name="message"]').first();

        if ($textarea.length) {
            $textarea.focus();
        }

        $closeButton.on('click', function () {
            mySelf.replyModeOff($conversationHolder);
        });

        $replyContainer.removeClass('hidden');
    }

    replyModeOff($conversationHolder) {
        let mySelf = this;
        mySelf.replyMode = false;

        let $form = $conversationHolder.find('[data-type="messageform"]').first();
        $form.find('.js-reply_message_id').val('');

        let $replyContainer = $conversationHolder.find('[data-type="messenger-reply-container"]');
        $replyContainer.addClass('hidden');
    }

    handleScrolltopTop(conversationID, $messagesContainer) {
        // ganz nach oben gescrollt, vorherige Messages laden
        if ($messagesContainer.scrollTop() == 0) {
            let $firstMessage = $messagesContainer.children('.message').first();
            if ($firstMessage.length == 1) {
                let loadingPrevious = $firstMessage.attr('data-loading-previous');
                if (loadingPrevious == 1) {
                    return;
                }
                $firstMessage.attr('data-loading-previous', 1);
                let firstMessageID = $firstMessage.attr('data-message-id');
                this.requestPreviousMessages(conversationID, firstMessageID);
            }
        }
    }

    handleScrolltopBottom(conversationID, $messagesContainer) {
        // ganz nach unten gescrollt, nächste Messages laden
        let scrollTop = $messagesContainer.scrollTop();
        let clientHeight = $messagesContainer.innerHeight();
        let scrollHeight = $messagesContainer.prop('scrollHeight');

        if ((scrollTop + clientHeight >= scrollHeight - 5)) {
            let $lastMessage = $messagesContainer.children('message[data-message-type="user"]').last();
            if ($lastMessage.length == 1) {
                let loadingNext = $lastMessage.attr('data-loading-next');
                if (loadingNext == 1) {
                    return;
                }
                $lastMessage.attr('data-loading-next', 1);
                let lastMessageID = $lastMessage.attr('data-message-id');

                if (lastMessageID != undefined) {
                    this.requestNextMessages(conversationID, lastMessageID);
                }
            }
        }
    }

    // Der Button ist anfangs ausgeblendet. Er erscheint, wenn der Benutzer nach oben scrollt
    // oder die "Gehe-zu-Nachricht"-Funktion nutzt, und wird wieder ausgeblendet, wenn bis ganz
    // nach unten gescrollt wird.
    // Der Button soll nicht bei jedem Scrollen ans Ende verschwinden, da dies nicht immer die
    // letzte Nachricht im Chat ist. Andernfalls würde er sofort wieder erscheinen, wenn neue
    // Nachrichten geladen werden. Stattdessen wird der Button nur ausgeblendet, wenn die
    // letzte Nachricht (bekannt durch ihre ID) geladen ist und der Benutzer tatsächlich
    // bis zum Ende gescrollt hat.
    handleGoToEndButton($messagesContainer, $gotoLastMessageBtn) {
        let currentScrollTop = $messagesContainer.scrollTop();
        let scrollHeight = $messagesContainer.prop("scrollHeight");
        let containerHeight = $messagesContainer.outerHeight();
        let lastMessageHeight = $messagesContainer.children().last().outerHeight() || 0;

        let $lastMessageInConversation = $messagesContainer.find("[data-message-id='" + this.currentLastMessageId + "']").first();
        let lastMessageLoaded = $lastMessageInConversation.length == 1;

        if (lastMessageLoaded && (scrollHeight - (currentScrollTop + containerHeight) <= lastMessageHeight / 4)) {
            // ganz nach unten gescrollt, Button verstecken
            if (!$gotoLastMessageBtn.hasClass('hidden')) {
                $gotoLastMessageBtn.addClass('hidden');
            }
        } else if (scrollHeight - (currentScrollTop + containerHeight) > lastMessageHeight) {
            // über eine Nachricht nach oben gescrollt, Button anzeigen
            if ($gotoLastMessageBtn.hasClass('hidden')) {
                $gotoLastMessageBtn.removeClass('hidden');
            }
        }
    }


    createNewConversation(jsonData) {
        if (jsonData.data === null) {
            return;
        }
        let mySelf = this;
        let conversationID = jsonData.data.id;

        let $conversationsContainer = $('#camchat-conversations-holder');

// Nach Verbindungsverlust und Reconnect muss der vorherige Container entfernt werden. PS: Das geht vermutlich besser
        $conversationsContainer.children('#conversation_' + conversationID).remove();

        let $conversationHolder = this.templatesWorker.createNewConversation($conversationsContainer, conversationID);

        $('#camchat-conversations-holder').children().addClass('hidden');
        $conversationHolder.removeClass('hidden');

        let $liveCamChatContainer = $('#livecamchat-container');
        let $camChatMainHeader = $liveCamChatContainer.find('[data-type="camchat-header"]').first();

        this.initMessageForm($conversationHolder, conversationID);

        if (this.mobileLayout) {
            $('#camchat-conversations-main-holder').removeClass('hidden');
        }

        mySelf.templatesWorker.fillUserData(
            $camChatMainHeader,
            jsonData.data.participants[0].userID,
            jsonData.data.participants[0].username,
            jsonData.data.participants[0].avatar,
            jsonData.data.participants[0].usertype,
            jsonData.data.participants[0].isOnline,
            '', //jsonData.data.last_message_time,
            jsonData.data.participants[0].verified,
            jsonData.data.participants[0].subscriber,
            jsonData.data.participants[0].follower
        );
    }


    initMessageForm($conversationHolder, conversationID) {
        let mySelf = this;

        let $form = $conversationHolder.find('[data-type="messageform"]').first();

        if ($form.length == 1) {

            let $gotoLastMessageBtn = $conversationHolder.find('[data-id="goto-last-msg-btn"]').first();
            $gotoLastMessageBtn.on('click', function () {
                // Der Benutzer möchte zum Ende der Nachrichten scrollen (zur neuesten Nachricht):
                // den gesamten Chat leeren, um Lücken zwischen den Nachrichten zu vermeiden, und letzte Nachrichten laden
                $gotoLastMessageBtn.addClass('hidden');
                mySelf.reloadConversation($conversationHolder, conversationID);
            });

            let $replyContainer = $conversationHolder.find('[data-type="messenger-reply-container"]').first();
            $replyContainer.attr('id', 'message_reply_' + conversationID);

            let $textarea = $form.find('textarea').first();
            $textarea.attr('id', 'message_input_' + conversationID);
            let shiftPressed = false;

            let $uploadButton = $form.find('[data-type="modalhandler"]').first();
            let uploadButtonModalData = 'twinID=' + $textarea.attr('id');
            $uploadButton.attr('data-modaldata', uploadButtonModalData);

            let $emojiButton = $form.find('[data-type="emojipicker"]').first();
            $emojiButton.attr('data-target-id', $textarea.attr('id'));
            $emojiButton.attr('data-state', 'init');

            let $gifButton = $form.find('[data-type="gifshandler"]').first();
            $gifButton.attr('data-content-id', conversationID);
            $gifButton.attr('data-target-id', 'gif_select_' + conversationID);
            $gifButton.attr('send_to', 0);
            $gifButton.attr('type', 'camchat');

            if ($gifButton.attr('data-state') == 'pre_init') {
                $gifButton.attr('data-state', 'init');
            }

            let $gifForm = $conversationHolder.find('[data-type="messenger-giphy-container"]').first();
            $gifForm.attr('id', 'gif_select_' + conversationID);

            $textarea.on('keydown', function (event) {
                    if (event.keyCode == 16) {
                        shiftPressed = true;
                    } else if (event.keyCode == 13) {
                        if (!shiftPressed) {
                            event.preventDefault();
                        }
                    }
                }
            );

            $textarea.on('keyup', function (event) {
                    if (event.keyCode == 16) {
                        shiftPressed = false;
                    }
                    if (event.keyCode == 13) {
                        if (!shiftPressed) {
                            event.preventDefault();
                            $form.submit();
                        }
                    }
                }
            );

            $textarea.on('keyup', throttle(function (event) {
                var replaceEmojiCodesWithEmoji = function (message) {
                    return message.split(' ').map(function (piece) {

                        if (emojisJson[piece] != undefined) {
                            let emoji = emojisJson[piece][0];
                            return emoji;
                        }
                        return piece;
                    }).join(' ');
                };

                let message = $textarea.val();
                message = replaceEmojiCodesWithEmoji(message);
                $textarea.val(message);
            }, 1000));

            $form.on("submit", function (event) {
                event.preventDefault();
                event.stopPropagation();

                let formData = $(this).serialize();

                if ($textarea.val().length < 2) {
                    $(document).trigger("toast:show", {
                        title: '',
                        subtitle: '',
                        body: $textarea.attr('data-error-txt'),
                        type: "notice",
                    });
                    return false;
                }
                let currentMd5Hash = md5($textarea.val().trim());
                mySelf.sentNewMessage(conversationID, formData, currentMd5Hash.toString());

                if (mySelf.replyMode) {
                    mySelf.replyModeOff($conversationHolder);
                }
            });

        }
    }


    /*********SOCKETMESSAGES*********/

    requestConversation() {
        let message = {};
        message.handler = "conversations";
        message.method = "startConversation";
        this.sendSocketMessage(message);
    }

    removeUserFromConversation(userId = null) {
        let message = {};
        message.handler = "conversations";
        message.method = "removeUserFromConversation";
        message.payload = {};
        message.payload.roomName = this.roomName;
        message.payload.userId = userId;
        this.sendSocketMessage(message);
    }

    deleteConversationMessage(messageID, conversationId = null) {
        let message = {};
        message.handler = "conversations";
        message.method = "deleteConversationMessage";
        message.payload = {};
        message.payload.messageID = messageID;
        message.payload.conversationId = conversationId;
        this.sendSocketMessage(message);
    }

    triggerNewSocketMessage(receiverID) {
        let message = {};
        message.type = "triggernewMessage";
        message.receiverID = receiverID;

        this.sendSocketMessage(message);
    }

    sentNewMessage(conversationID, formData, currentMd5Hash) {
        let message = {};
        message.handler = "conversations";
        message.method = "newMessage";
        message.payload = {};
        message.payload.conversationID = conversationID;
        message.payload.formData = formData;
        message.payload.currentMd5Hash = currentMd5Hash;
        this.sendSocketMessage(message);
    }

    sentPong(time) {
        let message = {};
        message.handler = "system";
        message.method = "pong";
        message.payload = {};
        message.payload.time = time;
        this.sendSocketMessage(message);
    }


    requestConversationData(conversationID, maxMessageID = null) {
        let message = {};
        message.handler = "conversations";
        message.method = "getConversationData";
        message.payload = {};
        message.payload.conversationID = conversationID;
        message.payload.maxMessageID = maxMessageID;
        this.sendSocketMessage(message);
    }


    requestPreviousMessages(conversationID, firstMessageID = null) {
        let message = {};
        message.handler = "conversations";
        message.method = "getPreviousMessages";
        message.payload = {};
        message.payload.conversationID = conversationID;
        message.payload.firstMessageID = firstMessageID;
        this.sendSocketMessage(message);
    }

    requestNextMessages(conversationID, lastMessageId) {
        let message = {};
        message.handler = "conversations";
        message.method = "getNextMessages";
        message.payload = {};
        message.payload.conversationID = conversationID;
        message.payload.lastMessageId = lastMessageId;
        this.sendSocketMessage(message);
    }

    createMessageReaction(messageId, reaction, conversationId) {
        let message = {};
        message.handler = "conversations";
        message.method = "createMessageReaction";
        message.payload = {};
        message.payload.messageId = messageId;
        message.payload.conversationId = conversationId;
        message.payload.reaction = reaction;
        this.sendSocketMessage(message);
    }

    handleClickedMessageReaction(messageId, clickedEmoji, conversationId) {
        let message = {};
        message.handler = "conversations";
        message.method = "handleClickedMessageReaction";
        message.payload = {};
        message.payload.messageId = messageId;
        message.payload.conversationId = conversationId;
        message.payload.reaction = clickedEmoji;
        this.sendSocketMessage(message);
    }

    sendGif(conversationId, sendTo, gif) {
        let formData = null;
        let $conversationHolder = $('#conversation_' + conversationId);

        let $form = $conversationHolder.find('[data-type="messageform"]').first();
        if ($form.length == 1) {
            formData = $form.serialize();
        }

        let message = {};
        message.handler = "conversations";
        message.method = "newMessage";
        message.payload = {};
        message.payload.conversationID = conversationId;
        message.payload.sendTo = sendTo;
        message.payload.gif = gif;
        message.payload.formData = formData;

        let $textarea = $form.find('textarea').first();
        if ($textarea.length == 1) {
            $textarea.val('');
        }
        this.replyModeOff($conversationHolder);

        this.sendSocketMessage(message);
    }

    sendSocketMessage(message) {
        // console.log('send socket camchat: ', message);
        let mySelf = this;
        let messageAsString = JSON.stringify(message);

        if (this.connection === null || this.connection.readyState != 1 || this.connecting) {
            // hier könnte man nicht versendbare Messages in die Warteschleife setzen
            return;
        }
        this.connection.send(messageAsString);
    }

    getCurrentFullScreenElement() {
        if (document.fullscreenElement != null) {
            return document.fullscreenElement;
        } else if (document.mozFullScreenElement != null) {
            return document.mozFullScreenElement;
        } else if (document.webkitFullscreenElement != null) {
            return document.webkitFullscreenElement;
        } else if (document.msFullscreenElement != null) {
            return document.msFullscreenElement;
        }
        return null;
    }

    destroyListener() {
        if (this.connection != null) {
            this.forceConnectionClose = true;
            this.connection.onclose = null;
            this.connectionCloseListener = null;
            this.connection.close();
            this.connection = null;
        }

        $(document).off('creator:camchat:start', this.camStartListener);
        $(document).off('user:camchat:start', this.camStartListener);
        $(document).off('creator:camchat:stop', this.camStopListener);
        $(document).off('user:camchat:stop', this.camStopListener);
        $(document).off("content:resized", this.contentResizedListener);
        $(document).off("chat:deleteMessage", this.chatDeleteMessageListener);
        $(document).off('camchat:reaction', this.camchatReactionListener);
        $(document).off('camchat:reaction:clicked', this.camchatReactionClickedListener);
        $(document).off('camchat:send_gif', this.camchatSendGifListener);

    }

}
